import { render } from "./balances-prof.vue?vue&type=template&id=5942bc66&scoped=true"
import script from "./balances-prof.vue?vue&type=script&lang=js"
export * from "./balances-prof.vue?vue&type=script&lang=js"

import "./balances-prof.vue?vue&type=style&index=0&id=5942bc66&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5942bc66"]])

export default __exports__